import { apiRoutes } from '@/constants/api-routes';
import { apiRequest } from './http';
import type { MonitoringAccountsListView, MonitoringOverview } from '@/types/api';

export interface ListMonitoringAccountsParams {
  take?: number;
  skip?: number;
  search?: string;
  filter?: 'all' | 'paid' | 'free';
}

/**
 * Admin-only monitoring API. Mirrors
 * `server/src/modules/monitoring/admin-monitoring.controller.ts`.
 */
export const adminMonitoringService = {
  /** Headline aggregates across accounts, engagement, kids activity, revenue. */
  overview() {
    return apiRequest<MonitoringOverview>(apiRoutes.adminMonitoring.overview);
  },

  /** Paginated account roster. Empty `search` / `all` filter are omitted so
   *  the server falls through to its defaults. */
  accounts(params: ListMonitoringAccountsParams = {}) {
    return apiRequest<MonitoringAccountsListView>(apiRoutes.adminMonitoring.accounts, {
      query: {
        take: params.take,
        skip: params.skip,
        search: params.search?.trim() || undefined,
        filter: params.filter && params.filter !== 'all' ? params.filter : undefined,
      },
    });
  },

  /**
   * Permanently delete an account and all its data. The server returns 409 if
   * the account still has an active, renewing subscription — it must be
   * canceled first.
   */
  deleteAccount(id: string) {
    return apiRequest<void>(`${apiRoutes.adminMonitoring.accounts}/${id}`, {
      method: 'DELETE',
    });
  },
};
